<template>
  <v-dialog
    v-model="auth.login"
    max-width="400"
    :fullscreen="$vuetify.breakpoint.xs"
    @click:outside="$store.commit('account/HIDE_AUTH_DIALOG')"
    @keydown.esc="$store.commit('account/HIDE_AUTH_DIALOG')"
  >
    <v-card
      hide-overlay
      rounded
      :loading="busy"
      :color="card.color || ''"
      light
    >
      <authenticate
        v-if="!auth.set"
        :options="options"
      />

      <profile
        v-if="auth.set"
        :stripe-options="stripeOptions"
        :user-slot="userSlot"
        :options="options"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import Authenticate from './authenticate/Index'
import Profile from './profile/Index'

export default {
  components: { Authenticate, Profile },
  props: {
    stripeOptions: {
      type: Object,
      default: ()=>{return {}}
    },
    userSlot: {
      type: Object,
      default: ()=>{return {}}
    },
    options: {
      type: Object,
      default: ()=>{return {}}
    }
  },
  data() {
    return {
      mode: 'login',
      busy: false
    }
  },
  computed: {
    card() {
      return this.options.card || {} 
    }
  },
  methods:{
    updateBusy(v){this.busy = v},
    forgotPassword(){
      this.mode = 'forgotPassword'
    },
  }
}
</script>